(function($, window) {
  if (window.mg === undefined)
    window.mg = {};

  var _ = window.mg;
  _.pages = {};

  _.getScrollbarWidth = function() {
    var scrollDiv = document.createElement('div');
    scrollDiv.style.position = 'absolute';
    scrollDiv.style.top      = '-9999px';
    scrollDiv.style.width    = '50px';
    scrollDiv.style.height   = '50px';
    scrollDiv.style.overflow = 'scroll';

    document.body.appendChild(scrollDiv);

    var scrollbarWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);

    return scrollbarWidth;
  };

  _.scrollTo = function(target, speed, additionalOffset) {
    var $target = $(target);
    var $header = $('#header');
    var offset = $target.offset().top + (additionalOffset || 0);
    var currentScroll = window.scrollY;

    if (currentScroll > offset) { // When scrolling upwards the header bar will most likely come into view, we need to scroll past the part of the screen that would otherwise be overlapped by the header
        offset -= $('.header-bar', $header).height();
    }

    offset = Math.max(0, offset); // Make sure the offset isn't accidentally a negative value, as that would mess with the animation speed (because it thinks it needs to scroll further than it actually does)

    $('html, body').stop().animate({ 'scrollTop': offset }, speed || 400, 'swing');
  };
  _.scrollToTop = function() {
    _.scrollTo(document.documentElement);
  };

  _.getRandomNumber = function(minimum, maximum) { // Inspired by GolfBox.T2.WebUI.Admin
    return Math.floor(Math.random() * (maximum - minimum + 1)) + minimum;
  };

  _.getUniqueNumber = function(length) { // Inspired by GolfBox.T2.WebUI.Admin
    var result = [];
    length = length ? length : 13;


    while (result.length < length) {
      var r = this.getRandomNumber(0, 9);

      if (result.length === 0 && r === 0)
        continue; // We don't want the beginning of the result to start with a 0

      result.push(r.toString());
    }

    return (+result.join(''));
  };

  _.redirect = function(url) {
    window.location = url;
  };

  _.resetErrorMessage = function(errorWrapper) {
    $(errorWrapper).removeClass('fade show').addClass('d-none');
  };

  _.showErrorMessage = function(errorMessage, errorWrapper, includeParagraph) {
    errorMessage = errorMessage.replace('\r\n', '<br>').replace('\n', '<br>');

    $('.error-message-main-content', errorWrapper).html(includeParagraph !== false ? '<p>' + errorMessage + '</p>' : errorMessage);
    $(errorWrapper).addClass('fade show').removeClass('d-none');
  };

  _.renderErrors = function(errors) {
    var errorsHTML = [];

    for (var i = 0; i < errors.length; i++) {
      errorsHTML.push('<p>', errors[i].formatText, '</p>'); // formatText comes from the validation at the moment, we may need to find a more general term
    }

    return errorsHTML.join('');
  };

  _.getUnknownErrorMsg = function(errorCode, errorCodeModulePrefix) {
    var errorCodeModulePrefixStr = errorCodeModulePrefix ? `${errorCodeModulePrefix}-` : '';
    var errorCodeStr = errorCode ? ` ${mg.translations.ErrorCode}: ${errorCodeModulePrefixStr}${errorCode}` : '';
    return `${mg.translations.UnknownError}.${errorCodeStr}`
  }


  _.logout = function() {
    _.ui.showPleaseWaitModal({ text: _.translations.PleaseWait, showTitle: false });

    _.ajax.get('/handlers/logout').done(function(data) {
      if (data) {
        _.redirect('/');
      }
    });
  };

  _.setTxtSearchBehavior = function(target, items, filterProp, ridProp, ridDataAttr) {
    // based on mingolf.ui.clearer.js - For now!
    var $input      = $('input[type="text"]', target);
    var $parent     = $input.parents('.mg-input');
    var $itemHolder = $parent.parent();
    var $clearer    = $('<i class="icon icon-close" aria-hidden="true"></i>');

    if ($input.data('txtsearchbehavior'))
      return;

    var updateClearer = function(status) {
      $parent.attr('data-cleareractive', status ? '1' : '0');
    };

    var updateResult = function() {
      var val     = $.trim($input.val());
      var results = [];

      if (val.length && items) {
        $.each(items, function(k, v) {
          var filterValue = v[filterProp].toLowerCase();
          var filterIndex = filterValue.indexOf(val.toLowerCase());

          if (filterIndex > -1) {
            v.filterIndex = filterIndex;
            results.push(v);
          }
        });
      }

      $('.filter-match', $itemHolder).each(function(idx, elem) {
        var $elem = $(elem);
        $elem.css('order', '');
        $elem.removeClass('filter-match');
      });

      if (val.length) {
        var dataAttr = ridDataAttr || ridProp.toLowerCase();

        results.sort(function(a, b) {
          var res = a.filterIndex - b.filterIndex;

          if (res === 0)
            res = a[filterProp] < b[filterProp] ? -1 : a[filterProp] > b[filterProp] ? 1 : 0;

          return res;
        });

        $itemHolder.addClass('filter-applied');

        $.each(results, function(i, v) {
          var $item = $('[data-' + dataAttr + '="' + v[ridProp] + '"]', $itemHolder);

          $item.css('order', i + 1);
          $item.addClass('filter-match');
        });
      } else {
        $itemHolder.removeClass('filter-applied');
      }
    };

    $input.data('txtsearchbehavior', true);
    $input.before($clearer);

    $input.on('focus.clearer-txtsearchbehavior', (e) => {
      if ($input.val().length >= 1)
        updateClearer(true);
    });

    $input.on('keyup.clearer-txtsearchbehavior', (e) => {
      if (e.which === 27) {
        $input.val('');
      }

      updateClearer($input.val().length >= 1);
      updateResult();
    });

    $input.on('input.clearer-txtsearchbehavior change.clearer-txtsearchbehavior paste.clearer-txtsearchbehavior', (e) => {
      updateClearer($input.val().length >= 1);
    });

    $clearer.on('mousedown.clearer-txtsearchbehavior', (e) => {
      e.preventDefault();
    });

    $clearer.on('click.clearer-txtsearchbehavior', (e) => {
      $input.val('');

      updateClearer(false);
      updateResult();

      $input.focus();

      e.preventDefault();
    });

    updateClearer(false);
  };

  _.showTerms = function(mode) {
    var url = 'https://help.golf.se/ovrigt/regelverk-for-git-och-min-golf';

    switch (mode) {
      case 'teetime':
      case 'membercard':
      case 'tournament':
      case 'olympiagolfen':
      case 'greenfeecheckar':
        url += '/allmanna-kopvillkor-starttidsbokning-i-min-golf/';
        break;
      case 'skandiatour':
        url += '/kopinformation-skandia-tour/';
        break;
      case 'nordeatour':
        url += '/kopinformation-nordea-tour-dam/';
        break;
      case 'prizetournament':
            url += '/kopinformation-for-tavling-med-prispengar/';
        break;
    }

    window.open(url);
  };

  _.onBoxClicked = function (box) {
    var url = '';
    var performSSO = true; // Whether or not we should try to perform an SSO operation

    switch (box) {
        case 'competitioncalendar':
            url = 'Competition/Search';
            break;
        case 'beta':
            url = '{oMG}/Beta';
            break;
        case 'welcome':
            url = 'Welcome';
            break;
        case 'rulesandhcp':
            url = 'http://golf.se/regler-och-handicap/';
            break;
        case 'sgt':
            url = 'https://golf.se/for-spelaren/tavlingar/swedish-golf-tour/';
            break;
        case 'teentour':
            url = 'https://golf.se/for-spelaren/tavlingar/juniortavlingar/';
            break;
        case 'moregolf':
            url = 'https://moregolf.golf.se/';
            break;
        case 'readgolfa':
            url = 'https://golfa.golf.se/';
            break;
        case 'tournews':
            url = 'https://golf.se/for-spelaren/tavlingar/tournytt2/';
            break;
        case 'klubbtv':
            url = 'https://www.klubbtv.nu/';
            break;
        case 'hioclub':
            url = 'https://www.hioklubben.se/';
            break;
        case 'safegolf':
            url = 'https://golf.se/sakergolf';
            break;
        case 'formats':
            url = 'https://golf.se/for-spelaren/spela-golf/spel--och-tavlingsformer/';
            break;
    }

    _.openTab(url);
  };

  _.openTab = function(url, performSSO) {
      performSSO = performSSO || performSSO == undefined; // Default to true

      if (url.indexOf('{oMG}') > -1) {
          url = url.replace('{oMG}', performSSO ? '' : _.oldMinGolf);

          if (performSSO)
              url = '/handlers/login/performSSO?redirectURL=' + encodeURIComponent(url);
      }

      window.open(url, '_blank');
    };

  _.showErrorModal = function(title, content) {
    mg.ui.errormodal({ html: '<div>' + content + '</div>', title: title });
  }

  _.showInactiveMembershipInfo = function () {
    mg.ui.errormodal({ html: '<div>' + mg.translations.YouDoNotHaveAnActiveMembershipInAnyClub + '</div>', title: mg.translations.NoActiveMembership });
  };

  _.showVIGHCPDisabledInfo = function () {
    mg.ui.errormodal({ html: '<div>' + mg.translations.YouGetYourHandicapWhenYouHaveCompletedGreenCard.replace('%linebreak%', '</div><div>').replace('%href%', 'https://borjaspela.golf.se') + '<div>', title: mg.translations.NotAllowed });
  };

  _.showModal = function(id) {
    mg.ui.minimodal({ modal: $(id) });
  };

  _.showOverlay = function (id, defaultOnCloseURL, onClosePages, confirmTitle, confirmText, confirmOnClose, confirmBtnYesText, confirmBtnNoText) {
    return mg.ui.overlay({ overlay: $(id), defaultOnCloseURL: defaultOnCloseURL, onClosePages: onClosePages, confirmTitle: confirmTitle, confirmCloseText: confirmText, showConfirmOnClose: confirmOnClose, confirmBtnYesText: confirmBtnYesText, confirmBtnNoText: confirmBtnNoText });
  };

  _.resolveError = function(errorMessage, requireMatch) {
    if (!errorMessage)
      return errorMessage;

    var compareMsg = errorMessage.toLowerCase().trim();

    if (compareMsg === 'missingright_booking')
      return mg.translations.YouDoNotHavePermissionToCompleteTheBooking;

    if (compareMsg === 'missingright_bookingwithprice')
      return mg.translations.YouDoNotHavePermissionToCompleteABookingThatRequiresPayment;

    if (compareMsg === 'missingright_competition')
      return mg.translations.YouDoNotHavePermissionToSignUpForCompetitions;

    if (compareMsg === 'missingright_competitionwithprice')
      return mg.translations.YouDoNotHavePermissionToSignUpForCompetitionsWithFees;

    if (compareMsg === 'missingright_payment')
      return mg.translations.YouDoNotHavePermissionToPayFeesInMinGolf;

    if (compareMsg === 'missingright_golflessons')
      return mg.translations.YouDoNotHavePermissionToBookGolfLessons;

    if (compareMsg.startsWith('missingright_'))
      return mg.translations.YouDoNotHaveSufficientRightsToPerformThisAction; // Fallback for unmapped missingright_ errors.

    return requireMatch ? null : errorMessage; // We either return the errorMessage we received, or null if a match is required
  }

  function createFunctionWithTimeout(callback, opt_timeout) {
    var called = false;

    function fn() {
      if (!called) {
        called = true;
        callback();
      }
    }

    setTimeout(fn, opt_timeout || 1000);
    return fn;
  }

  _.gaEvent = function(action, category, label, callback) {
    if (!window.gtag) {
      if (callback && $.isFunction(callback))
        callback();
      return;
    }

    var o = {};

    if (category !== null)
      o['event_category'] = category;

    if (label !== null)
      o['event_label'] = label;

    if (callback && $.isFunction(callback))
      o['event_callback'] = createFunctionWithTimeout(callback);

    gtag('event', action, o);
  };

  _.getGenderIconClass = function(gender) {
    var g = parseInt(gender);

    if (!isNaN(g)) {
      var res = gender === 0 ? 'woman' : gender === 1 ? 'man' : 'gender-unknown';

      return 'avatar-' + res;
    }

    return '';
  };

  _.removeTrailingSlash = function(str) {
    if (str && str.substr(-1) === '/')
      str = str.substr(0, str.length - 1);

    return str;
  };

  _.children = {
    orphans: [],
    register: function(parentName, obj) {
      this.orphans.push($.extend({
        parentName: parentName
      }, obj));
    },
    adopt: function(parentName) {
      // Return all children waiting for this parent
      var children = [];

      for (var i = 0; i < this.orphans.length; i++) {
        var orphan = this.orphans[i];

        if (orphan.parentName == parentName) {
          $.isFunction(orphan.initCallback) && orphan.initCallback(); // Execute any callbacks
          children.push(orphan);
          this.orphans.splice(i, 1); // Remove this children from the orphans list
          i--; // Go back one step to make sure we don't accidentally skip a poor child
        }
      }

      return children; // The callbacks may not be finished yet. If we ever need this to happen only when they are all finished, we need to use a callback instead
    },
    findChild: function(childName, children) {
      var child = null;

      children && $.each(children, function(k, v) {
        if (v.identifier === childName) {
          child = v;
          return false; // Break the loop
        }
      });

      return child;
    }
  };

  function pad(n) {
    return n < 10 ? '0' + n : n + '';
  }

  _.actions = {
      onClick: function (target, onClick) {
          if (target.getAttribute('disabled') === 'disabled') {
              mg.showInactiveMembershipInfo();
              return; // Don't do anything further
          }

          if ($.isFunction(onClick))
              onClick();
          else if (typeof (onClick) == 'string')
              eval(onClick);
      },
      open: function (href, onOpen, onClose, onCloseURL, overlayUIExtraProps = {} ) { // Open an overlay with the specified href
        var overlay = mg.ui.overlay({
              ...overlayUIExtraProps,
              href: href,
              instantSpinner: true,
              onOpen: function () {
                  $('.advertising-content').filter(':not(.allow-in-overlay)').find('> *').remove(); // Remove all ads (except any ads added specifically in the overlay), as they do not know they are not visible. This is a temporary solution until Booking is rebuilt (the only page with an actual overlay, the rest aren't including the ads).
                  $('#esmg-full-page-ads').parents('[style*="z-index"]').remove(); // Same goes for the splash ad (we can only recognize the splash parent by it having a z-index in its style attribute - I would have much preferred something more stable, but I didn't have any luck coordinating that with them the last time).
                  $.isFunction(onOpen) && onOpen();
              },
              onClose: function () {
                  $.isFunction(onClose) && onClose();

                  var reloadOnClose = true; // Necessary until Booking is rebuilt

                  if (reloadOnClose) { // Reload the page to get the ads back (wrapped in an if statement to have it easily grouped)
                      if (onCloseURL) // Implementations can specify a specific URL to go to when closing the overlay (used for the quickbooking implementation for now, as it would otherwise be stuck in a loop where closing the overlay reloads the page, which automatically opens the overlay again)
                          window.location = onCloseURL;
                      else
                          location.reload();
                  }
              }
              // TODO - Custom footer, or can we just add the buttons we need?
          });
      },
      findTeeTime: function (slotID, showPaymentDirectly, onOpen) {
          _.actions.open('/Site/Booking' + (slotID ? '/' + slotID : '') + (showPaymentDirectly ? '/true': ''), onOpen, () => {
              if (_.pages && _.pages.booking && _.pages.booking.teetimes && _.pages.booking.teetimes.grid.activeCell && _.pages.booking.teetimes.grid.activeCell.src) {
                  _.pages.booking.teetimes.grid.activeCell.src.Slot && _.pages.booking.slot.cancel(_.pages.booking.teetimes.grid.activeCell.src.Slot.SlotId);
              }
          });
      },
      searchCompetition: function () {
          _.action.open('/Site/Competition');
      }
  }

  _.url = {
    encode: function (string) { return escape(this._utf8_encode(string)); },
    decode: function (string) { return this._utf8_decode(unescape(string)); },
    _utf8_encode: function (string) { string = string.replace(/\r\n/g, '\n'); var utftext = ''; for (var n = 0; n < string.length; n++) { var c = string.charCodeAt(n); if (c < 128) { utftext += String.fromCharCode(c); } else if ((c > 127) && (c < 2048)) { utftext += String.fromCharCode((c >> 6) | 192); utftext += String.fromCharCode((c & 63) | 128); } else { utftext += String.fromCharCode((c >> 12) | 224); utftext += String.fromCharCode(((c >> 6) & 63) | 128); utftext += String.fromCharCode((c & 63) | 128); } } return utftext; },
    _utf8_decode: function (utftext) { var string = ''; var i = 0; var c = c1 = c2 = 0; while (i < utftext.length) { c = utftext.charCodeAt(i); if (c < 128) { string += String.fromCharCode(c); i++; } else if ((c > 191) && (c < 224)) { c2 = utftext.charCodeAt(i + 1); string += String.fromCharCode(((c & 31) << 6) | (c2 & 63)); i += 2; } else { c2 = utftext.charCodeAt(i + 1); c3 = utftext.charCodeAt(i + 2); string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63)); i += 3; } } return string; }
  }

  // https://github.com/kaimallea/isMobile

  var IsMobileClass = function(userAgent) {
    var ua = userAgent || navigator.userAgent;

    var apple_phone         = /iPhone/i,
        apple_ipod          = /iPod/i,
        apple_tablet        = /iPad/i,
        android_phone       = /(?=.*\bAndroid\b)(?=.*\bMobile\b)/i, // Match 'Android' AND 'Mobile'
        android_tablet      = /Android/i,
        amazon_phone        = /(?=.*\bAndroid\b)(?=.*\bSD4930UR\b)/i,
        amazon_tablet       = /(?=.*\bAndroid\b)(?=.*\b(?:KFOT|KFTT|KFJWI|KFJWA|KFSOWI|KFTHWI|KFTHWA|KFAPWI|KFAPWA|KFARWI|KFASWI|KFSAWI|KFSAWA)\b)/i,
        windows_phone       = /Windows Phone/i,
        windows_tablet      = /(?=.*\bWindows\b)(?=.*\bARM\b)/i, // Match 'Windows' AND 'ARM'
        other_blackberry    = /BlackBerry/i,
        other_blackberry_10 = /BB10/i,
        other_opera         = /Opera Mini/i,
        other_chrome        = /(CriOS|Chrome)(?=.*\bMobile\b)/i,
        other_firefox       = /(?=.*\bFirefox\b)(?=.*\bMobile\b)/i, // Match 'Firefox' AND 'Mobile'
        seven_inch = new RegExp(
            '(?:' +         // Non-capturing group
            'Nexus 7' +     // Nexus 7
            '|' +           // OR
            'BNTV250' +     // B&N Nook Tablet 7 inch
            '|' +           // OR
            'Kindle Fire' + // Kindle Fire
            '|' +           // OR
            'Silk' +        // Kindle Fire, Silk Accelerated
            '|' +           // OR
            'GT-P1000' +    // Galaxy Tab 7 inch
            ')',            // End non-capturing group
            'i');           // Case-insensitive matching

    function match(regex, str) {
      return regex.test(str);
    }

    // Facebook mobile app's integrated browser adds a bunch of strings that
    // match everything. Strip it out if it exists.
    var tmp = ua.split('[FBAN');

    if (typeof tmp[1] !== 'undefined') {
      ua = tmp[0];
    }

    // Twitter mobile app's integrated browser on iPad adds a "Twitter for
    // iPhone" string. Same probable happens on other tablet platforms.
    // This will confuse detection so strip it out if it exists.
    tmp = ua.split('Twitter');

    if (typeof tmp[1] !== 'undefined') {
      ua = tmp[0];
    }

    this.apple = {
      phone  : match(apple_phone, ua),
      ipod   : match(apple_ipod, ua),
      tablet : !match(apple_phone, ua) && match(apple_tablet, ua),
      device : match(apple_phone, ua) || match(apple_ipod, ua) || match(apple_tablet, ua)
    };

    this.amazon = {
      phone  : match(amazon_phone, ua),
      tablet : !match(amazon_phone, ua) && match(amazon_tablet, ua),
      device : match(amazon_phone, ua) || match(amazon_tablet, ua)
    };

    this.android = {
      phone  : match(amazon_phone, ua) || match(android_phone, ua),
      tablet : !match(amazon_phone, ua) && !match(android_phone, ua) && (match(amazon_tablet, ua) || match(android_tablet, ua)),
      device : match(amazon_phone, ua) || match(amazon_tablet, ua) || match(android_phone, ua) || match(android_tablet, ua)
    };

    this.windows = {
      phone  : match(windows_phone, ua),
      tablet : match(windows_tablet, ua),
      device : match(windows_phone, ua) || match(windows_tablet, ua)
    };

    this.other = {
      blackberry   : match(other_blackberry, ua),
      blackberry10 : match(other_blackberry_10, ua),
      opera        : match(other_opera, ua),
      firefox      : match(other_firefox, ua),
      chrome       : match(other_chrome, ua),
      device       : match(other_blackberry, ua) || match(other_blackberry_10, ua) || match(other_opera, ua) || match(other_firefox, ua) || match(other_chrome, ua)
    };

    this.seven_inch = match(seven_inch, ua);
    this.any        = this.apple.device || this.android.device || this.windows.device || this.other.device || this.seven_inch;

    // excludes 'other' devices and ipods, targeting touchscreen phones
    this.phone  = this.apple.phone || this.android.phone || this.windows.phone;

    // excludes 7 inch devices, classifying as phone or tablet is left to the user
    this.tablet = this.apple.tablet || this.android.tablet || this.windows.tablet;

    return this;
  };

  _.isMobile = new IsMobileClass();

  _.isDesktopLayout = function() {
    return window.matchMedia && window.matchMedia('(min-width: 992px)').matches;
  };

  _.ping = function() {
    return _.ajax.get({
      url   : '/Ping',
      cache : false
    });
  };

  _.countDown = function(secs, tick, callback) {
    var funcObj = function() {
      var that = this;
      var on = false;
      var timer;

      that.left = secs;

      that.count = function() {
        if (that.left <= 0) {
          $.isFunction(callback) && callback(that);
          return;
        }

        if ($.isFunction(tick)) {
          tick(that.left--);
        } else {
          that.left--;
        }

        if (timer)
          clearTimeout(timer);

        timer = setTimeout(that.count, 1000);
      };

      that.start = function() {
        if (!on) {
          on = true;
          that.count();
        }
      };

      that.stop = function() {
        on = false;
        clearTimeout(timer);
      };

      that.reset = function() {
        that.stop();
        that.resetTimer();
        that.start();
      };

      that.resetTimer = function() {
        that.left = secs;
      };
    };

    return new funcObj();
  };

    _.startsWith = function(str, starts) {
        if (starts === '') return true;
        if (str == null || starts == null) return false;
        str = String(str);
        starts = String(starts);
        return str.length >= starts.length && str.slice(0, starts.length) === starts;
    };

    _.endsWith = function(str, ends) {
        if (ends === '') return true;
        if (str == null || ends == null) return false;
        str = String(str);
        ends = String(ends);
        return str.length >= ends.length && str.slice(str.length - ends.length) === ends;
    };

    _.cookie = function (key, value, settings) { // Copied from oMG
        settings = $.extend({}, settings);

        var encode = encodeURIComponent;
        var decode = decodeURIComponent;
        var expires = settings.expires;
        var result = value;

        if (!key) {
            result = {};

            $.each(document.cookie.split('; '), function (i, cookie) {
                if (!cookie)
                    return;
                var parts = cookie.split('=');
                result[decode(parts[0])] = JSON.parse(decode(parts[1]));
            });

            return result;
        }

        key = encode(key);

        if (value === undefined) {
            result = new RegExp('(?:^|; )' + key + '=([^;]*)').exec(document.cookie);
            return result && JSON.parse(decode(result[1]));
        } else {
            if (value === null)
                expires = -1;

            if (typeof expires === 'number')
                expires = new Date((new Date()).getTime() + expires);

            document.cookie = [
                key, '=', encode(JSON.stringify(value)),
                expires ? '; expires=' + expires.toUTCString() : '',
                settings.path ? '; path=' + settings.path : '',
                settings.domain ? '; domain=' + settings.domain : '',
                settings.secure ? '; secure' : ''
            ].join('');
        }

        return result;
    };

    _.renderThankYouPageAd = function() {
        return _.adsRenderConceptX('cncpt-tack_mob1', 'cncpt-tack_lb1');
    };

    _.adsRenderConceptX = function (mobileTagId, desktopTagId) {
        var tagId = window.matchMedia ? window.matchMedia('(min-width: 992px)').matches ? desktopTagId : mobileTagId : null;
        return '<div id="' + tagId + '"></div>';
    };

  function extendObject(deep, target, obj) {
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        if (deep) {
          if (isObject(obj[key])) {
            target[key] = extendObject(true, [target[key], obj[key]]);
          } else if (Array.isArray(obj[key]) && Array.isArray(target[key])) {
            target[key] = target[key].concat(obj[key]);
          } else {
            target[key] = obj[key];
          }
        } else {
          target[key] = obj[key];
        }
      }
    }
  }

  function isObject(obj) {
    return Object.prototype.toString.call(obj) === '[object Object]';
  }

  _.namespace = _.ns = function(namespace, obj) {
    var namespaces = namespace.split('.');
    var index     = 0;
    var lastIndex = namespaces.length - 1;
    var container = window;

    for (; index <= lastIndex; index++) {
      var current = namespaces[index];

      if (container[current] === undefined) {
        if ((index === lastIndex) && isObject(obj)) {
          container[current] = obj;
        } else {
          container[current] = {};
        }
      } else if (isObject(container[current])) {
        if ((index === lastIndex) && isObject(obj)) {
          extendObject(true, container[current], obj);
        }
      } else {
        throw ('Invalid namespace "' + namespaces.slice(0, index + 1).join('.') + '" is unavailable');
      }

      container = container[current];
    }

    return container;
  };

  _.lilumStartTransaction = function(id) {
      try {
          window.lilum_startTransaction && lilum_startTransaction('mg_' + id);
      } catch {
          // Do nothing for now, we just don't want this to cause any errors.
      }
  };

  _.lilumStopTransaction = function(id) {
      try {
          window.lilum_stopTransaction && lilum_stopTransaction('mg_' + id);
      } catch {
          // Do nothing for now, we just don't want this to cause any errors.
      }
  };
})(jQuery, window);
